"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeroImageNewCssComponent = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _helper = require("../utils/helper");

var _useOnsiteMessagingImpressionEvent = require("../../../../internal/OnsiteMessageEventingHooks/useOnsiteMessagingImpressionEvent");

var _useOnsiteMessagingIntentToShowEvent = require("../../../../internal/OnsiteMessageEventingHooks/useOnsiteMessagingIntentToShowEvent");

var _HeroImage = require("./HeroImage");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeroImageNewCssComponent = function HeroImageNewCssComponent(_ref) {
  var mobileImg = _ref.mobileImg,
      mobileImg2x = _ref.mobileImg2x,
      mobileWebp = _ref.mobileWebp,
      mobileWebp2x = _ref.mobileWebp2x,
      tabletPortraitImg = _ref.tabletPortraitImg,
      tabletPortraitImg2x = _ref.tabletPortraitImg2x,
      tabletPortraitWebp = _ref.tabletPortraitWebp,
      tabletPortraitWebp2x = _ref.tabletPortraitWebp2x,
      tabletLandscapeImg = _ref.tabletLandscapeImg,
      tabletLandscapeImg2x = _ref.tabletLandscapeImg2x,
      tabletLandscapeWebp = _ref.tabletLandscapeWebp,
      tabletLandscapeWebp2x = _ref.tabletLandscapeWebp2x,
      desktopImg = _ref.desktopImg,
      desktopImg2x = _ref.desktopImg2x,
      desktopWebp = _ref.desktopWebp,
      desktopWebp2x = _ref.desktopWebp2x,
      eventData = _ref.eventData,
      newLaneEventData = _ref.newLaneEventData,
      additionalClickStreamData = _ref.additionalClickStreamData,
      Head = _ref.Head;
  var ref = (0, _useOnsiteMessagingImpressionEvent.useOnsiteMessagingImpressionEvent)({
    eventData: eventData,
    newLaneEventData: newLaneEventData,
    additionalClickStreamData: additionalClickStreamData
  });
  (0, _useOnsiteMessagingIntentToShowEvent.useOnsiteMessagingIntentToShowEvent)({
    eventData: eventData,
    newLaneEventData: newLaneEventData,
    additionalClickStreamData: additionalClickStreamData
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: ref
  }, /*#__PURE__*/_react.default.createElement(_HeroImage.HeroImage, {
    mobileImg: (0, _helper.imageSrc)(mobileImg),
    mobileImg2x: (0, _helper.imageSrc)(mobileImg2x),
    mobileWebp: (0, _helper.imageSrc)(mobileWebp),
    mobileWebp2x: (0, _helper.imageSrc)(mobileWebp2x),
    tabletPortraitImg: (0, _helper.imageSrc)(tabletPortraitImg),
    tabletPortraitImg2x: (0, _helper.imageSrc)(tabletPortraitImg2x),
    tabletPortraitWebp: (0, _helper.imageSrc)(tabletPortraitWebp),
    tabletPortraitWebp2x: (0, _helper.imageSrc)(tabletPortraitWebp2x),
    tabletLandscapeImg: (0, _helper.imageSrc)(tabletLandscapeImg),
    tabletLandscapeImg2x: (0, _helper.imageSrc)(tabletLandscapeImg2x),
    tabletLandscapeWebp: (0, _helper.imageSrc)(tabletLandscapeWebp),
    tabletLandscapeWebp2x: (0, _helper.imageSrc)(tabletLandscapeWebp2x),
    desktopImg: (0, _helper.imageSrc)(desktopImg),
    desktopImg2x: (0, _helper.imageSrc)(desktopImg2x),
    desktopWebp: (0, _helper.imageSrc)(desktopWebp),
    desktopWebp2x: (0, _helper.imageSrc)(desktopWebp2x),
    Head: Head
  }));
};

exports.HeroImageNewCssComponent = HeroImageNewCssComponent;
HeroImageNewCssComponent.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Identifies mobile image media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  mobileImg: _propTypes.default.object.isRequired,

  /**
   * Identifies mobile image 2x media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  mobileImg2x: _propTypes.default.object.isRequired,

  /**
   * Identifies mobile webp media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  mobileWebp: _propTypes.default.object.isRequired,

  /**
   * Identifies mobile webp 2x media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  mobileWebp2x: _propTypes.default.object.isRequired,

  /**
   * Identifies tablet portrait image media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  tabletPortraitImg: _propTypes.default.object.isRequired,

  /**
   * Identifies tablet portrait image 2x media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  tabletPortraitImg2x: _propTypes.default.object.isRequired,

  /**
   * Identifies tablet portrait webp media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  tabletPortraitWebp: _propTypes.default.object.isRequired,

  /**
   * Identifies tablet portrait webp 2x media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  tabletPortraitWebp2x: _propTypes.default.object.isRequired,

  /**
   * Identifies tablet landscape image media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  tabletLandscapeImg: _propTypes.default.object.isRequired,

  /**
   * Identifies tablet landscape image 2x media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  tabletLandscapeImg2x: _propTypes.default.object.isRequired,

  /**
   * Identifies tablet landscape webp media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  tabletLandscapeWebp: _propTypes.default.object.isRequired,

  /**
   * Identifies tablet landscape webp 2x media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  tabletLandscapeWebp2x: _propTypes.default.object.isRequired,

  /**
   * Identifies desktop image media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  desktopImg: _propTypes.default.object.isRequired,

  /**
   * Identifies desktop image 2x media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  desktopImg2x: _propTypes.default.object.isRequired,

  /**
   * Identifies desktop webp media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  desktopWebp: _propTypes.default.object.isRequired,

  /**
   * Identifies desktop webp 2x media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  desktopWebp2x: _propTypes.default.object.isRequired,

  /**
   * Event data object, passed by parent component
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  eventData: _propTypes.default.object,

  /**
   * New Lane Event data object, passed by parent component
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  newLaneEventData: _propTypes.default.object,

  /**
   * Additional Clickstream data object, passed by parent component
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  additionalClickStreamData: _propTypes.default.object,

  /**
   * Head to pass to <HeroImage>
   */
  // eslint-disable-next-line zillow/react/require-default-props
  Head: _propTypes.default.func
} : {};
HeroImageNewCssComponent.defaultProps = {
  eventData: {},
  newLaneEventData: {},
  additionalClickStreamData: {},
  Head: undefined
};